import React from 'react';
import Check from '@mui/icons-material/Brightness1';

interface Props {
  checked?: boolean;
}

const IconRadio: React.FC<Props> = ({ checked }) => {
  return <div className="icon">{checked && <Check />}</div>;
};

export default IconRadio;
